<template>
  <Page>
    <template #action>
      <BaseLink
        class="text-sm flex flex-row items-center"
        to="operator.dictionary"
      >
        <BaseIcon class="mr-3" name="arrow-left" width="4" height="8" />
        Вернуться назад
      </BaseLink>
    </template>
    <template #title>
      Редактирование заявки
      <span v-if="request.id">№ {{ request.id }}</span>
    </template>

    <div
      v-if="isLoading"
      class="w-full h-full flex flex-row items-center justify-center"
    >
      <BaseLoader size="3xl" />
    </div>
    <DictionaryForm v-else :data="request" :disabled-fields="disabledFields" />
  </Page>
</template>

<script>
  import {mapGetters, mapState} from 'vuex';

  import Page from '@/components/layouts/main/page/index';
  import BaseLink from '@/components/global/base-link/index';
  import BaseIcon from '@/components/global/base-icon/index';
  import BaseLoader from '@/components/global/base-loader/index';
  import DictionaryForm from '@/components/views/dictionary/form/index';

  export default {
    name: 'OperatorDictionaryRequestPage',

    components: {
      Page,
      BaseLink,
      BaseIcon,
      BaseLoader,
      DictionaryForm,
    },

    data() {
      return {
        disabled: [
          'id',
          'fio',
          'email',
          'phone',
          'value',
          'position',
          'location',
          'comment',
          'dictionary',
          'lmsp_list',
          'condition_name',
          'condition_question',
          'life_situation_id',
        ],

        isLoading: false,
      };
    },

    computed: {
      ...mapGetters('Auth', ['hasRole']),
      ...mapState('DictionaryRequest', ['request']),

      disabledFields() {
        if (this.hasRole(['pdf', 'mintrud'])) {
          return this.disabled;
        }
        return this.disabled.filter((x) => {
          return ['condition_name', 'condition_question'].indexOf(x) === -1;
        });
      },
    },

    created() {
      this.isLoading = true;

      this.$store
        .dispatch('DictionaryRequest/loadForOperator', this.$route.params.id)
        .then(() => {
          this.isLoading = false;
        })
        .catch(() => {
          this.$store.commit('Notification/showAlert', {
            title: 'Ошибка!',
            message:
              'Произошла ошибка, пожалуйста попробуйте обновить страницу.',
          });
        });
    },

    destroyed() {
      this.$store.dispatch('DictionaryRequest/clear');
    },
  };
</script>
